import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TabItem } from 'components/general/TabStrip';
import { useFlag } from 'lane-shared/hooks';
import { useWorkOrderTenantSurveysEnabled } from 'react-hooks';
import { FeatureFlag } from 'constants-flags';

export enum Tabs {
  MessageNotification = 'messageNotification',
  WorkOrderSurveys = 'workOrderSurveys',
}

export const useWorkOrderConfigurationTabs = () => {
  const { t } = useTranslation();
  const isWorkOrderSurveysEnabled = useWorkOrderTenantSurveysEnabled();
  const isWorkOrderCommentsNotificationEnabled = useFlag(
    FeatureFlag.WorkOrderCommentNotificationEmail,
    false
  );

  const tabs: TabItem[] = [];

  if (isWorkOrderCommentsNotificationEnabled) {
    tabs.push({
      value: Tabs.MessageNotification,
      label: t('web.admin.work-order.configuration.message.notification.tab.title'),
    });
  }

  if (isWorkOrderSurveysEnabled) {
    tabs.push({
      value: Tabs.WorkOrderSurveys,
      label: t('web.admin.work-order.configuration.workOrderSurveys.tab.title'),
    });
  }

  const [selectedTab, setSelectedTab] = useState<TabItem | null>(
    tabs.length > 0 ? tabs[0] : null
  );

  return { tabs, selectedTab, setSelectedTab };
};
  